import React, { memo } from 'react';
import { View } from 'react-native';
import Collapsible from 'utils/packages/rnCollapsible';
import { Indicator, rem } from 'design-system';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const FeatureCard = ({ isFetching, title, description, noDescriptionMargin, isCollapsed, onPressCancel, cta, onPressCta, image, style, }) => {
    const styles = useStyles(styleSet);
    const content = (<>
      <View style={styles.content}>
        <View style={styles.flex}>
          {!!title && <Text Text-16>{title}</Text>}
          {!!description && (<View style={[
                styles.description,
                !noDescriptionMargin && styles.descriptionMargin,
            ]}>
              <Text TextThin-14 Secondary>
                {description}
              </Text>
            </View>)}
        </View>
        {!!image && <View>{image}</View>}
      </View>
      <View>
        {isFetching ? (<Indicator light/>) : (<View style={styles.button}>
            <Button brandLight square medium cards title={cta} onPress={onPressCta}/>
            <Spacer w={8}/>
            <Button brandBorder square medium cards title="Dismiss" onPress={onPressCancel}/>
          </View>)}
      </View>
    </>);
    if (isCollapsed === undefined) {
        return <View style={[styles.container, style]}>{content}</View>;
    }
    return (<Collapsible style={[styles.container, style]} collapsed={isCollapsed}>
      {content}
    </Collapsible>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        // styles from js/tabs/feed/cards/Recommendation.js
        marginHorizontal: rem(16),
        marginBottom: rem(16),
        padding: rem(16),
        borderRadius: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    flex: {
        flex: 1,
    },
    content: {
        flexGrow: 1,
        flexDirection: 'row',
    },
    description: {
        marginBottom: rem(20),
        marginTop: rem(4),
    },
    descriptionMargin: {
        marginRight: rem(40),
    },
    button: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
}));
export default memo(FeatureCard);
